<template>
  <div class="assignment-rates">
    <table>
      <thead>
        <tr class="rate-header">
          <th>{{ $t('assignment.labels.formLabels.rateType') }}</th>
          <th>{{ $t('assignment.labels.formLabels.payRate') }}</th>
          <th>{{ $t('assignment.labels.formLabels.billRate') }}</th>
          <th>{{ $t('assignment.labels.formLabels.hourRange') }}</th>
          <th>{{ $t('assignment.labels.formLabels.effectiveDate') }}</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(rate, idx) in rates" :key="idx">
          <td>
            {{ rate.rate_code }}
          </td>
          <td>
            {{ rate.amount_pay }}
          </td>
          <td>
            {{ rate.amount_bill }}
          </td>
          <td>
            {{ rate.hour_range }}
          </td>
          <td>
            <form-date-picker
              v-if="isRemoveSelected(idx)"
              :value="getFormattedDate(rate.effective_date)"
              :type="normalOrHighlighted"
              @change="changeEffectiveDate($event, idx)"
            >
            </form-date-picker>
            <span v-else>{{ rate.effective_date | formatDate }}</span>
          </td>
          <td class="rate-add">
            <font-awesome-icon icon="times-circle" @click="setRemoveIndex(idx)" />
          </td>
        </tr>
        <tr v-if="insert" class="insert-row">
          <td>
            <dropdown-select
              v-if="!newRowData.rate_code"
              :menu-items="rateTypes"
              :selected-item="null"
              :filter-on="['code', 'description']"
              class="bordered small"
              @select-item="changeRateCode($event)"
            >
              <template v-slot:selectedItem="{ value }">
                {{ value.code }} - {{ value.description }}
              </template>
              <template v-slot:dropdownItem="{ value }">
                {{ value.code }} - {{ value.description }}
              </template>
            </dropdown-select>
            <input v-else v-model="newRowData.rate_code" type="text" class="rate-row-input" />
          </td>
          <td>
            <input
              v-model="newRowData.amount_pay"
              type="text"
              name="pay-rate"
              class="rate-row-input"
            />
          </td>
          <td>
            <input
              v-model="newRowData.amount_bill"
              type="text"
              name="bill-rate"
              class="rate-row-input"
            />
          </td>
          <td>
            <input
              v-model="newRowData.hour_range"
              type="text"
              name="hour-range"
              class="rate-row-input"
            />
          </td>
          <td>
            <form-date-picker
              v-if="!newRowData.effective_date"
              v-model="newRowData.effective_date"
              type="bordered"
              @change="changeEffectiveDate($event)"
            >
            </form-date-picker>
            <span v-else>{{ newRowData.effective_date | formatDate }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import DropdownSelect from '@/app/components/DropdownSelect';
import FormDatePicker from '@/app/components/FormDatePicker';
export default {
  components: {
    DropdownSelect,
    FormDatePicker
  },
  props: {
    rates: {
      type: Array,
      required: true
    },
    insertRow: {
      type: Object,
      default: null
    },
    insert: {
      type: Boolean,
      default: false
    },
    rateTypes: {
      type: Array,
      default: () => []
    },
    assignmentStatus: {
      type: String
    }
  },
  data() {
    return {
      canInsert: false,
      rateCodeSelected: false,
      newRowData: null,
      isRemoveBtnClicked: false,
      remove: {},
      statuses: ['DRAFT', 'SUBMITTED', 'APPROVED']
    };
  },
  computed: {
    normalOrHighlighted() {
      return this.isRemoveBtnClicked ? 'bordered error' : 'bordered';
      //return 'bordered'
    }
  },
  watch: {
    insertRow: {
      immediate: true,
      handler(val) {
        this.newRowData = Object.assign({}, val);
      }
    },
    newRowData: {
      immediate: true,
      deep: true,
      handler(val) {
        if (val) {
          this.canInsert =
            this.rateCodeSelected &&
            val.rate_code &&
            val.amount_bill &&
            val.amount_pay &&
            val.effective_date;
        }
        if (this.canInsert) {
          this.emitInsertMessage();
        }
      }
    }
  },
  methods: {
    getFormattedDate(theDate) {
      const parts = theDate.split('-');
      return new Date(parseInt(parts[0], 10), parseInt(parts[1], 10) - 1, parseInt(parts[2], 10));
    },

    isRemoveSelected(index) {
      return this.remove[index];
    },
    changeEffectiveDate(evt, idx = null) {
      if (idx === null) {
        this.$set(this.newRowData, 'effective_date', evt);
      } else {
        this.$emit('update', {
          action: 'remove',
          data: { rate_code: this.rates[idx].rate_code, effective_date: evt }
        });
        this.remove[idx] = false;
      }
      this.isRemoveBtnClicked = false;
    },
    changeRateCode(evt) {
      this.rateCodeSelected = true;
      this.newRowData.rate_code = evt.code;
    },
    emitInsertMessage() {
      this.$emit('update', {
        action: 'add',
        data: this.newRowData
      });
      this.newRowData = Object.assign({}, this.insertRow);
      this.rateCodeSelected = false;
    },
    setRemoveIndex(index) {
      this.isRemoveBtnClicked = true;
      if (
        !this.rates[index].assignment_id ||
        (this.rates[index].assignment_id && this.statuses.includes(this.assignmentStatus))
      ) {
        this.$emit('update', {
          action: 'remove',
          data: { rate_code: this.rates[index].rate_code }
        });
      } else {
        this.$set(this.remove, index, true);
      }
    }
  }
};
</script>

<style scoped lang="scss">
@import '@/app/styles/colors.scss';
@import '@/app/styles/variables.scss';

.assignment-rates {
  table {
    table-layout: fixed;
    border-collapse: collapse;
    thead {
      border-bottom: 2px solid $row_border;
    }
    thead tr th {
      text-transform: uppercase;
      font-size: 0.7em;
      background-color: $background-level-3;
      padding: 8px 0;
    }

    thead tr.rate-header {
      th {
        &:not(:first-of-type) {
          text-align: center;
        }
        &:not(:nth-of-type(5)) {
          border-right: 1px solid $row-border;
        }
        &:last-of-type {
          border-right: 0;
        }
      }
    }

    tbody tr {
      &:nth-child(even) {
        background-color: $background-level-3;
        input {
          border: 0;
          border-left: 2px solid $background-level-3;
          border-right: 2px solid $background-level-3;
          background-color: $white;
        }
      }
      &:nth-child(odd) {
        input {
          border: 0;
          border-left: 2px solid $white;
          border-right: 2px solid $white;
          background-color: $background-level-3;
        }
      }
    }
    tbody tr td {
      padding: 8px 0;
      &:not(:nth-of-type(1)) {
        text-align: center;
      }
      &.rate-add {
        text-align: right;
        padding-right: 5px;
        svg {
          font-size: 1.2em;
          color: $row-border;
          &:hover {
            cursor: pointer;
            color: $red;
          }
        }
        div {
          margin: auto;
          padding: 4px 0;
          font-size: 0.7em;
          font-weight: bold;
          text-align: center;
          width: 100%;
          color: $white;
          background-color: $green;
          &:hover {
            cursor: pointer;
          }
        }
      }
    }

    tbody tr.insert-row {
      td {
        width: inherit;
        //padding: 0 2px;
        input {
          padding: 8px 0;
          height: 40px;
          background-color: $white;
          border: 1px solid $row-border;
          &:focus {
            outline: none;
          }
        }
        &.rate-add {
          text-align: right;
          svg {
            &:hover {
              color: $green;
            }
          }
        }
      }
    }
  }
}
</style>
